module.exports = __webpack_public_path__ + "static/media/5f8de7ed5ae7590275f0750e_banner_800x600.adb7c6ee.png";